module.exports = __webpack_public_path__ + "img/personal-info.c7e58da7.svg";